/**
 * Keep Trade Cut Player IDs for Draft Picks
 * Maps (season, round, tier) to KTC player ID
 */

// KTC IDs for draft picks (Early/Mid/Late for each round)
// Source: https://keeptradecut.com/dynasty-rankings
const KTC_PICK_IDS = {
  // 2026 Picks
  '2026-1-early': 1527,
  '2026-1-mid': 1528,
  '2026-1-late': 1529,
  '2026-2-early': 1530,
  '2026-2-mid': 1531,
  '2026-2-late': 1532,
  '2026-3-early': 1533,
  '2026-3-mid': 1534,
  '2026-3-late': 1535,
  '2026-4-early': 1536,
  '2026-4-mid': 1537,
  '2026-4-late': 1538,

  // 2027 Picks
  '2027-1-early': 1702,
  '2027-1-mid': 1703,
  '2027-1-late': 1704,
  '2027-2-early': 1705,
  '2027-2-mid': 1706,
  '2027-2-late': 1707,
  '2027-3-early': 1708,
  '2027-3-mid': 1709,
  '2027-3-late': 1710,
  '2027-4-early': 1711,
  '2027-4-mid': 1712,
  '2027-4-late': 1713,

  // 2028 Picks
  '2028-1-early': 1882,
  '2028-1-mid': 1883,
  '2028-1-late': 1884,
  '2028-2-early': 1885,
  '2028-2-mid': 1886,
  '2028-2-late': 1887,
  '2028-3-early': 1888,
  '2028-3-mid': 1889,
  '2028-3-late': 1890,
  '2028-4-early': 1891,
  '2028-4-mid': 1892,
  '2028-4-late': 1893,
};

/**
 * Get KTC player ID for a draft pick
 *
 * @param {string} season - Year (e.g., "2026")
 * @param {number} round - Round number (1-4)
 * @param {string} tier - Tier: "early", "mid", or "late" (defaults to "mid")
 * @returns {number|null} KTC player ID or null if not found
 */
export function getKTCPickId(season, round, tier = 'mid') {
  const key = `${season}-${round}-${tier}`;
  return KTC_PICK_IDS[key] || null;
}

/**
 * Get KTC player ID for a pick, using tier if available
 *
 * @param {Object} pick - Pick object with season, round, and optional tier
 * @returns {number|null} KTC player ID or null
 */
export function getKTCPickIdFromPick(pick) {
  if (!pick || !pick.season || !pick.round) {
    return null;
  }

  // Use tier from pick if available, otherwise default to "mid"
  const tier = pick.tier || 'mid';
  return getKTCPickId(pick.season, pick.round, tier);
}
